import { render, staticRenderFns } from "./TypeOne.vue?vue&type=template&id=27ae9534&scoped=true&"
import script from "./TypeOne.vue?vue&type=script&lang=js&"
export * from "./TypeOne.vue?vue&type=script&lang=js&"
import style0 from "./TypeOne.vue?vue&type=style&index=0&id=27ae9534&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ae9534",
  null
  
)

export default component.exports